import { render, staticRenderFns } from "./CenterMenu.vue?vue&type=template&id=de2f5e8e&scoped=true"
import script from "./CenterMenu.vue?vue&type=script&lang=js"
export * from "./CenterMenu.vue?vue&type=script&lang=js"
import style0 from "./CenterMenu.vue?vue&type=style&index=0&id=de2f5e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2f5e8e",
  null
  
)

export default component.exports